<style scoped>

</style>

<template>
    <div>
        <h1>竞猜列表</h1>
        <div>
          <div v-for="(item,index) in guessList" :key="index" class="list-item">            
            <div class="text">{{item.guessName}}</div>
            <el-button type="primary" @click="showGuessSwitch(item.guessId)">竞猜开关</el-button>
          </div>
        </div>
    </div>
</template>

<script>
import app from '@/App.vue';
import { getGuessList } from '@/request/api';
export default {
    name: 'ActivityList',
    data() {
      return {
        guessList: []
      };
    },
    methods: {
      getGuessList() {
        getGuessList().then(res => {
            var status = res.status;
            var msg = res.msg;
            if (status === '2') {
                this.$message.error(msg);
            } else {
                this.$message.success("查询成功");
                var data = res.data;
                this.guessList = data;
            }
        })
      },
      showGuessSwitch(guessId) {
        this.$router.push("/Layout/guessSwitch?guessId=" + guessId).catch(error => error);
      },
    },
    created(){
        this.getGuessList();
    }
}
</script>


<style scoped>
.list-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 10px;
}
.text {
  font-size: 20px;
  width: 100px;
  height: 30px;
  line-height: 30px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/page/guess/guessList.vue